import type {ArtemisService} from '@aiw/config';

export type CommonServiceMeasurements={floorAreaM2:number;skirtingRunM:number;stairSteps:number;doorways:number};

/** Use the registered quantity basis; manual services begin at one and remain editable in the proposal. */
export function commonServiceQuantity(basis:ArtemisService['basis'],m:CommonServiceMeasurements):number{
 switch(basis){
  case 'floor_area':return m.floorAreaM2;
  case 'skirting_run':return m.skirtingRunM;
  case 'stair_steps':return m.stairSteps;
  case 'doorways':return m.doorways;
  case 'manual':return 1;
 }
}

const SPECIALISED=new Set(['remove_dispose','skirting','door_trim','stair_work','carpet_stair_install']);
/** Specialised controls keep their product/removal rules; every other registered service is a quick pick. */
export function quickPickServices<T extends {id:string}>(services:T[]):T[]{return services.filter(service=>!SPECIALISED.has(service.id));}
